import React, { Component } from 'react';
import _ from 'lodash';

import LocationForwardlocationsTable from '../components/LocationForwardlocationsTable';
import LocationForwardForm from '../components/LocationForwardForm';

import LocationForwardlocationsModel from '../components/LocationForwardlocationsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon, message } from 'antd';

class LocationForwardlocationsScreen extends Component {

    state = {
        dataLoading: true,
        dataAll: [],
        data: [],
        parkinglocationFormModalVisible: false,
        parkinglocationFormDefaultValues: null,
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        this.setState({
            dataLoading: true
        });
        LocationForwardlocationsModel.getAll()
            .then(data => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data
                });
            });
    }

    onSearch(searchText) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => { return d['name'].toLowerCase().includes(searchText.toLowerCase()); })
        })
    }

    render() {
        return (
            <Layout.Content style={{ margin: '24px 16px 0' }}>
                <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                    <h2>Forward lokalit - Seznam lokalit</h2>
                    <div style={{ marginBottom: '20px' }}>
                        <Row>
                            <Col span={8}>
                                <Input.Search
                                    placeholder="Název lokality"
                                    onSearch={this.onSearch.bind(this)}
                                    style={{ width: 300 }} />
                            </Col>
                            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                                <Button type="default" onClick={() => { this.loadData(true) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                                {UserModel.isInRoles(['ADMIN', 'LOCATION_FORWARD_WRITE'])
                                    ? <Button type="default" onClick={() => { this.setState({ parkinglocationFormModalVisible: true }) }}>Nová lokalita</Button>
                                    : null}
                            </Col>
                        </Row>
                    </div>
                    <LocationForwardForm
                        type="modal"
                        modalVisible={this.state.parkinglocationFormModalVisible}
                        defaultValues={this.state.parkinglocationFormDefaultValues}
                        onModalCancel={(form) => {
                            form.resetFields();
                            this.setState({
                                parkinglocationFormModalVisible: false,
                                parkinglocationFormDefaultValues: null
                            });
                        }}
                        onSuccess={(form, values) => {
                            LocationForwardlocationsModel.create(values)
                                .then(() => {
                                    message.success('Lokalita byla vložena!');
                                    form.resetFields();
                                    this.setState({
                                        parkinglocationFormModalVisible: false,
                                        parkinglocationFormDefaultValues: null
                                    });
                                    this.loadData(true);
                                });
                        }} />
                    <LocationForwardlocationsTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onDetailRow={(record) => {
                            this.setState({
                                parkinglocationFormModalVisible: true,
                                parkinglocationFormDefaultValues: record
                            });
                        }}
                        onRemoveRow={(_id) => {
                            LocationForwardlocationsModel.remove(_id)
                                .then(() => {
                                    message.success('Lokalita byla smazána!');
                                    this.loadData();
                                });
                        }}
                        onAnyFormSuccess={() => {
                            this.loadData();
                        }} />
                </div>
            </Layout.Content>
        );
    }
}

export default LocationForwardlocationsScreen;



// WEBPACK FOOTER //
// ./src/screens/LocationForwardlocationsScreen.js